// @flow
import { ReducerRegistry } from "../../../../base/redux";
import {
    CHANGE_ACIENT,
    SELECT_LANGUAGE,
    SET_CHAT_SENDER_LANG,
    SET_CHAT_SPEECH_DETECT,
    SET_CHAT_TRANSLATOR_STATUS,
    SET_CHAT_USER_SPEAKING,
    SET_LANGUAGE_GENDER,
    SET_START_SPEECH_TIMER
} from "./actionTypes"

/**
 * The name of the redux store/state property which is the root of the redux
 * state of the feature {@code customise-app}.
 */
export const CHAT_CUSTOM_STORE = 'features/customise/app/chat';

/**
 * Reduces redux actions for the purposes of the feature {@code customise-app}.
 */

const DEFAULT_STATE = {
    // lang: 'en-us',
    lang: '',
    langForm: 'FEMALE',
    chatUserSpeaking: false,
    isChatFirstWordDetect: false,
    chatSenderLanguage: "",
    chatTranslatorStatus: false,
    chatLanguageGender: "",
    startSpeechTimer: 0
}

ReducerRegistry.register(CHAT_CUSTOM_STORE, (state = DEFAULT_STATE, action) => {
    switch (action.type) {

        case SELECT_LANGUAGE:
            return {
                ...state,
                lang: action.lang
            };

        case CHANGE_ACIENT:
            return {
                ...state,
                langForm: action.langForm
            };
        case SET_CHAT_USER_SPEAKING:
            return {
                ...state,
                chatUserSpeaking: action.chatUserSpeaking
            };
        case SET_CHAT_SPEECH_DETECT:
            return {
                ...state,
                isChatFirstWordDetect: action.isChatFirstWordDetect
            };
        case SET_CHAT_SENDER_LANG:
            return {
                ...state,
                chatSenderLanguage: action.chatSenderLanguage
            };
        case SET_CHAT_TRANSLATOR_STATUS:
            return {
                ...state,
                chatTranslatorStatus: action.chatTranslatorStatus
            };
        case SET_LANGUAGE_GENDER:
            return {
                ...state,
                chatLanguageGender: action.chatLanguageGender
            };
        case SET_START_SPEECH_TIMER:
            return {
                ...state,
                startSpeechTimer: action.startSpeechTimer
            };
    }

    return state;
});
